const BATCH_STATUS = {
  processed: 'PROCESSED',
  processing: 'PROCESSING',
}

export {
  BATCH_STATUS,
}
